<template>
  <v-dialog v-model="intDialogVisible" max-width="900px" class="addValueModal addComment">
    <v-card>
      <v-card-title>
        <h3 class="primary--text formName">{{formName}}</h3>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3"  @submit.prevent="submit">
        <div class="col-12">
              <span class="fieldTitle">API Key</span>
            <v-text-field  class="addValueInput" placeholder="Enter Affinity API Key"  v-model="affinityConfig.apikey"></v-text-field>
        </div>

        <div class="col-12">
              <span class="fieldTitle">Target list ID</span>
            <v-text-field  class="addValueInput" placeholder="Enter the ID of targeted list"  v-model="affinityConfig.list_id"></v-text-field>
        </div>

        <div class="col-12">
              <span class="fieldTitle">Description field ID</span>
            <v-text-field  class="addValueInput" placeholder="Enter the ID of the description field"  v-model="affinityConfig.description_field_id"></v-text-field>
        </div>

        <div class="col-12">
              <span class="fieldTitle">Status field ID</span>
            <v-text-field  class="addValueInput" placeholder="Enter the ID of the status field"  v-model="affinityConfig.status_field_id"></v-text-field>
        </div>
        <div class="col-12">
              <span class="fieldTitle">Initial review status ID</span>
            <v-text-field  class="addValueInput" placeholder="Enter the ID of status when assessment done"  v-model="affinityConfig.status_initial_review_id"></v-text-field>
        </div>

        <div class="col-12">
              <span class="fieldTitle">Affinity status ID for low interest</span>
            <v-text-field  class="addValueInput" placeholder="Enter the ID of status when interest status is set to LOW"  v-model="affinityConfig.status_low_interest_id"></v-text-field>
        </div>
        <div class="col-12">
              <span class="fieldTitle">Affinity status ID for medium interest</span>
            <v-text-field  class="addValueInput" placeholder="Enter the ID of status when interest status is set to MEDIUM"  v-model="affinityConfig.status_medium_interest_id"></v-text-field>
        </div>
        <div class="col-12">
              <span class="fieldTitle">Affinity status ID for high interest</span>
            <v-text-field  class="addValueInput" placeholder="Enter the ID of status when interest status is set to HIGH"  v-model="affinityConfig.status_high_interest_id"></v-text-field>
        </div>


          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" >
              Close
            </v-btn>
            <v-btn class="addValue" @click="submit" >
              Set configuration
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { toast } from 'vue-sonner'
import api from '@/tools/api';
export default {
  props: {
    dialogVisible: Boolean,
    formName: String,
    userToConfig: Object
  },
  data () {
    return{
      user:{},
      affinityConfig:{
        apikey : null,
        list_id: null,
        status_initial_review_id: null,
        description_field_id: null,
        status_field_id : null,
        status_low_interest_id:null,
  status_medium_interest_id:null,
  status_high_interest_id:null,
      },
    }
  },
  methods:{
    submit(){
      console.log(this.user);
      console.log(this.affinityConfig);
      //const hasNullOrEmpty = Object.values(this.affinityConfig).some(value => value === null || value === "");
      var hasNullOrEmpty = false;
      if(this.affinityConfig.apikey == null || this.affinityConfig.list_id == null || this.affinityConfig.status_initial_review_id == null || this.affinityConfig.description_field_id == null || this.affinityConfig.status_field_id == null){
        hasNullOrEmpty = true;
      }
      if(this.affinityConfig.apikey == '' || this.affinityConfig.list_id == '' || this.affinityConfig.status_initial_review_id == '' || this.affinityConfig.description_field_id == '' || this.affinityConfig.status_field_id == ''){
        hasNullOrEmpty = true;
      }
      if(hasNullOrEmpty){
        toast.error("Please provide all field to ensure a valid connection with Affinity");
      }
      else{
          api.post(process.env.VUE_APP_API_URL+"/restrict/setNewAffinityConfig",
          {
            affinityConfig : this.affinityConfig,
            user : this.user._id.$oid
          },
          { headers: {'Content-Type': 'application/json',}}
        ).then( (r) => {
          console.log(r);
          this.affinityConfig.apikey = null;
          this.affinityConfig.list_id = null;
          this.affinityConfig.status_initial_review_id = null;
          this.affinityConfig.description_field_id = null;
          this.affinityConfig.status_field_id = null;
          this.affinityConfig.status_low_interest_id = null;
          this.affinityConfig.status_medium_interest_id = null;
          this.affinityConfig.status_high_interest_id = null;

          toast.success(r.data.message)
          this.$emit('newValueIsProposed',true)
        }).catch( (e) => {
          console.log(e);
          if(e.response.data.message){
            toast.error(e.response.data.message)
          }
          else{
            toast.error(e.message);

          }
        });
      }

    },
    close(){
        this.$emit('close',false)
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
      this.affinityConfig.apikey = null;
      this.affinityConfig.list_id = null;
      this.affinityConfig.status_initial_review_id = null;
      this.affinityConfig.description_field_id = null;
      this.affinityConfig.status_field_id = null;
      this.affinityConfig.status_low_interest_id = null;
      this.affinityConfig.status_medium_interest_id = null;
      this.affinityConfig.status_high_interest_id = null;
      if(this.userToConfig){
        this.user = this.userToConfig;
        if(Object.prototype.hasOwnProperty.call(this.userToConfig, "affinityConfig")){
          this.affinityConfig = Object.assign(this.affinityConfig,this.userToConfig.affinityConfig);
        }
      }

    }
  }

}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  }


      .fieldTitle{
        font-weight:600;
        display:block;
      }
</style>
